import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, Inject, NgZone, Output, EventEmitter, OnDestroy } from '@angular/core';
import { getCurrencySymbol, DOCUMENT, Location, formatDate, isPlatformBrowser } from '@angular/common';
import { ThemeService } from '../../services/theme.service';
import { Option } from '../settings/menu/option.model';
import { AuthServiceService } from '../../services/auth-service.service';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { PermissionService } from 'src/app/core/services/permission.service';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { map, startWith, takeUntil } from 'rxjs/operators';
import * as Moment from 'moment-timezone';
import { PLATFORM_ID } from '@angular/core';


class lcoale {
  currency: string;
  timeZone: String;
  dateFormat: String;
  timeFormat: string;
  decimalFormat: String;
  digitFormat: String;
}

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy {
  @Output() selectedDateFormatChanged: EventEmitter<string> = new EventEmitter();

  timeZoneControl = new UntypedFormControl('');
  currencyControl = new UntypedFormControl('');
  filteredTimezoneOptions: Observable<string[]>;
  filteredCurrencyOptions: Observable<string[]>;
  //Local Variable
  displayDate: any;
  displayTime: any;
  customDisplayTime: any;
  customDisplayDate: any;
  selectedCurrency = 'Indian Rupee';
  selectedTimeZone: any = Moment.tz.guess();
  selectedDateFormat: any = 'MM-dd-yyyy';
  selectedTimeFormat: any = 'hh:mm';
  selectedCustomTimeFormat: any = 'hh:mm a';
  selectedCustomDateFormat: any = 'MM-dd-yyyy';
  seletedDigitFormat: any = '12,34,56,789';
  seletedDecimalFormat: any = '.';
  direction: string = 'ltr';
  timeZoneLists: any = Moment.tz.names();
  isBrowser: any;
  private destroy$ = new Subject<void>();

  get router() {
    return this._router;
  }
  // length 164
  currency_list = [
    { name: 'Afghan Afghani', code: 'AFA' },
    { name: 'Albanian Lek', code: 'ALL' },
    { name: 'Algerian Dinar', code: 'DZD' },
    { name: 'Angolan Kwanza', code: 'AOA' },
    { name: 'Argentine Peso', code: 'ARS' },
    { name: 'Armenian Dram', code: 'AMD' },
    { name: 'Aruban Florin', code: 'AWG' },
    { name: 'Australian Dollar', code: 'AUD' },
    { name: 'Azerbaijani Manat', code: 'AZN' },
    { name: 'Bahamian Dollar', code: 'BSD' },
    { name: 'Bahraini Dinar', code: 'BHD' },
    { name: 'Bangladeshi Taka', code: 'BDT' },
    { name: 'Barbadian Dollar', code: 'BBD' },
    { name: 'Belarusian Ruble', code: 'BYR' },
    { name: 'Belgian Franc', code: 'BEF' },
    { name: 'Belize Dollar', code: 'BZD' },
    { name: 'Bermudan Dollar', code: 'BMD' },
    { name: 'Bhutanese Ngultrum', code: 'BTN' },
    { name: 'Bitcoin', code: 'BTC' },
    { name: 'Bolivian Boliviano', code: 'BOB' },
    { name: 'Bosnia-Herzegovina Convertible Mark', code: 'BAM' },
    { name: 'Botswanan Pula', code: 'BWP' },
    { name: 'Brazilian Real', code: 'BRL' },
    { name: 'British Pound Sterling', code: 'GBP' },
    { name: 'Brunei Dollar', code: 'BND' },
    { name: 'Bulgarian Lev', code: 'BGN' },
    { name: 'Burundian Franc', code: 'BIF' },
    { name: 'Cambodian Riel', code: 'KHR' },
    { name: 'Canadian Dollar', code: 'CAD' },
    { name: 'Cape Verdean Escudo', code: 'CVE' },
    { name: 'Cayman Islands Dollar', code: 'KYD' },
    { name: 'CFA Franc BCEAO', code: 'XOF' },
    { name: 'CFA Franc BEAC', code: 'XAF' },
    { name: 'CFP Franc', code: 'XPF' },
    { name: 'Chilean Peso', code: 'CLP' },
    { name: 'Chinese Yuan', code: 'CNY' },
    { name: 'Colombian Peso', code: 'COP' },
    { name: 'Comorian Franc', code: 'KMF' },
    { name: 'Congolese Franc', code: 'CDF' },
    { name: 'Costa Rican ColÃ³n', code: 'CRC' },
    { name: 'Croatian Kuna', code: 'HRK' },
    { name: 'Cuban Convertible Peso', code: 'CUC' },
    { name: 'Czech Republic Koruna', code: 'CZK' },
    { name: 'Danish Krone', code: 'DKK' },
    { name: 'Djiboutian Franc', code: 'DJF' },
    { name: 'Dominican Peso', code: 'DOP' },
    { name: 'East Caribbean Dollar', code: 'XCD' },
    { name: 'Egyptian Pound', code: 'EGP' },
    { name: 'Eritrean Nakfa', code: 'ERN' },
    { name: 'Estonian Kroon', code: 'EEK' },
    { name: 'Ethiopian Birr', code: 'ETB' },
    { name: 'Euro', code: 'EUR' },
    { name: 'Falkland Islands Pound', code: 'FKP' },
    { name: 'Fijian Dollar', code: 'FJD' },
    { name: 'Gambian Dalasi', code: 'GMD' },
    { name: 'Georgian Lari', code: 'GEL' },
    { name: 'German Mark', code: 'DEM' },
    { name: 'Ghanaian Cedi', code: 'GHS' },
    { name: 'Gibraltar Pound', code: 'GIP' },
    { name: 'Greek Drachma', code: 'GRD' },
    { name: 'Guatemalan Quetzal', code: 'GTQ' },
    { name: 'Guinean Franc', code: 'GNF' },
    { name: 'Guyanaese Dollar', code: 'GYD' },
    { name: 'Haitian Gourde', code: 'HTG' },
    { name: 'Honduran Lempira', code: 'HNL' },
    { name: 'Hong Kong Dollar', code: 'HKD' },
    { name: 'Hungarian Forint', code: 'HUF' },
    { name: 'Icelandic KrÃ³na', code: 'ISK' },
    { name: 'Indian Rupee', code: 'INR' },
    { name: 'Indonesian Rupiah', code: 'IDR' },
    { name: 'Iranian Rial', code: 'IRR' },
    { name: 'Iraqi Dinar', code: 'IQD' },
    { name: 'Israeli New Sheqel', code: 'ILS' },
    { name: 'Italian Lira', code: 'ITL' },
    { name: 'Jamaican Dollar', code: 'JMD' },
    { name: 'Japanese Yen', code: 'JPY' },
    { name: 'Jordanian Dinar', code: 'JOD' },
    { name: 'Kazakhstani Tenge', code: 'KZT' },
    { name: 'Kenyan Shilling', code: 'KES' },
    { name: 'Kuwaiti Dinar', code: 'KWD' },
    { name: 'Kyrgystani Som', code: 'KGS' },
    { name: 'Laotian Kip', code: 'LAK' },
    { name: 'Latvian Lats', code: 'LVL' },
    { name: 'Lebanese Pound', code: 'LBP' },
    { name: 'Lesotho Loti', code: 'LSL' },
    { name: 'Liberian Dollar', code: 'LRD' },
    { name: 'Libyan Dinar', code: 'LYD' },
    { name: 'Lithuanian Litas', code: 'LTL' },
    { name: 'Macanese Pataca', code: 'MOP' },
    { name: 'Macedonian Denar', code: 'MKD' },
    { name: 'Malagasy Ariary', code: 'MGA' },
    { name: 'Malawian Kwacha', code: 'MWK' },
    { name: 'Malaysian Ringgit', code: 'MYR' },
    { name: 'Maldivian Rufiyaa', code: 'MVR' },
    { name: 'Mauritanian Ouguiya', code: 'MRO' },
    { name: 'Mauritian Rupee', code: 'MUR' },
    { name: 'Mexican Peso', code: 'MXN' },
    { name: 'Moldovan Leu', code: 'MDL' },
    { name: 'Mongolian Tugrik', code: 'MNT' },
    { name: 'Moroccan Dirham', code: 'MAD' },
    { name: 'Mozambican Metical', code: 'MZM' },
    { name: 'Myanmar Kyat', code: 'MMK' },
    { name: 'Namibian Dollar', code: 'NAD' },
    { name: 'Nepalese Rupee', code: 'NPR' },
    { name: 'Netherlands Antillean Guilder', code: 'ANG' },
    { name: 'New Taiwan Dollar', code: 'TWD' },
    { name: 'New Zealand Dollar', code: 'NZD' },
    { name: 'Nicaraguan CÃ³rdoba', code: 'NIO' },
    { name: 'Nigerian Naira', code: 'NGN' },
    { name: 'North Korean Won', code: 'KPW' },
    { name: 'Norwegian Krone', code: 'NOK' },
    { name: 'Omani Rial', code: 'OMR' },
    { name: 'Pakistani Rupee', code: 'PKR' },
    { name: 'Panamanian Balboa', code: 'PAB' },
    { name: 'Papua New Guinean Kina', code: 'PGK' },
    { name: 'Paraguayan Guarani', code: 'PYG' },
    { name: 'Peruvian Nuevo Sol', code: 'PEN' },
    { name: 'Philippine Peso', code: 'PHP' },
    { name: 'Polish Zloty', code: 'PLN' },
    { name: 'Qatari Rial', code: 'QAR' },
    { name: 'Romanian Leu', code: 'RON' },
    { name: 'Russian Ruble', code: 'RUB' },
    { name: 'Rwandan Franc', code: 'RWF' },
    { name: 'Salvadoran ColÃ³n', code: 'SVC' },
    { name: 'Samoan Tala', code: 'WST' },
    { name: 'Saudi Riyal', code: 'SAR' },
    { name: 'Serbian Dinar', code: 'RSD' },
    { name: 'Seychellois Rupee', code: 'SCR' },
    { name: 'Sierra Leonean Leone', code: 'SLL' },
    { name: 'Singapore Dollar', code: 'SGD' },
    { name: 'Slovak Koruna', code: 'SKK' },
    { name: 'Solomon Islands Dollar', code: 'SBD' },
    { name: 'Somali Shilling', code: 'SOS' },
    { name: 'South African Rand', code: 'ZAR' },
    { name: 'South Korean Won', code: 'KRW' },
    { name: 'Special Drawing Rights', code: 'XDR' },
    { name: 'Sri Lankan Rupee', code: 'LKR' },
    { name: 'St. Helena Pound', code: 'SHP' },
    { name: 'Sudanese Pound', code: 'SDG' },
    { name: 'Surinamese Dollar', code: 'SRD' },
    { name: 'Swazi Lilangeni', code: 'SZL' },
    { name: 'Swedish Krona', code: 'SEK' },
    { name: 'Swiss Franc', code: 'CHF' },
    { name: 'Syrian Pound', code: 'SYP' },
    { name: 'São Tomé and Príncipe Dobra', code: 'STD' },
    { name: 'Tajikistani Somoni', code: 'TJS' },
    { name: 'Tanzanian Shilling', code: 'TZS' },
    { name: 'Thai Baht', code: 'THB' },
    { name: "Tongan Pa'anga", code: 'TOP' },
    { name: 'Trinidad & Tobago Dollar', code: 'TTD' },
    { name: 'Tunisian Dinar', code: 'TND' },
    { name: 'Turkish Lira', code: 'TRY' },
    { name: 'Turkmenistani Manat', code: 'TMT' },
    { name: 'Ugandan Shilling', code: 'UGX' },
    { name: 'Ukrainian Hryvnia', code: 'UAH' },
    { name: 'United Arab Emirates Dirham', code: 'AED' },
    { name: 'Uruguayan Peso', code: 'UYU' },
    { name: 'US Dollar', code: 'USD' },
    { name: 'Uzbekistan Som', code: 'UZS' },
    { name: 'Vanuatu Vatu', code: 'VUV' },
    { name: 'Venezuelan BolÃvar', code: 'VEF' },
    { name: 'Vietnamese Dong', code: 'VND' },
    { name: 'Yemeni Rial', code: 'YER' },
    { name: 'Zambian Kwacha', code: 'ZMK' },
  ];

  themes: any = [
    { name: 'Appiworks Default', value: 'default' },
    { name: 'Indigo & Pink', value: 'angular-theme-1' },
    { name: 'Deep Purple & Amber', value: 'angular-theme-2' },
    { name: 'Pink & Blue Grey', value: 'angular-theme-3' },
    { name: 'Purple & Green', value: 'angular-theme-4' },
  ];

  dateFormat: any = [
    { name: 'Long Date - EEEE, MMMM dd, YYYY', value: 'EEEE, MMMM dd, YYYY'},
    { name: 'Medium Date - MMM dd, YYYY', value: 'MMM dd, YYYY'},
    { name: 'Short Date - MM-dd-YYYY', value: 'MM-dd-YYYY'},
    { name: 'Custom Date Format', value: 'custom'}
  ];
  timeFormat: any = [
    { name: 'Long Time - hh:mm:ss a', value: 'hh:mm:ss a' },
    { name: 'Medium Time - hh:mm a', value: 'hh:mm a' },
    { name: 'Short Time - HH:mm', value: 'HH:mm' },
    { name: 'Custom Time Format', value: "custom" },
  ];
  decimalFormat: any = [
    { name: '.', description: 'Dot' },
    { name: ',', description: 'Comma' },
    { name: "'", description: 'Apostrophe' },
    { name: '·', description: 'Interpunct' },
  ];
  digitFormat: any = [
    {
      value: '123456789',
    },
    {
      value: '123,456,789',
    },
    {
      value: '123456,789',
    },
    {
      value: '12,34,56,789',
    },
  ];
  isDarkTheme: boolean;
  options: Array<any> = [
    {
      backgroundColor: '#fff',
      buttonColor: '#036a85',
      headingColor: '#c3e5fa',
      label: 'AppiWorks Default',
      value: 'aw-brand',
    },
    {
      backgroundColor: '#fff',
      buttonColor: '#ffc107',
      headingColor: '#673ab7',
      label: 'Deep Purple & Amber',
      value: 'deeppurple-amber',
    },
    {
      backgroundColor: '#fff',
      buttonColor: '#ff4081',
      headingColor: '#3f51b5',
      label: 'Indigo & Pink',
      value: 'indigo-pink',
    },
    {
      backgroundColor: '#fff',
      buttonColor: '#607d8b',
      headingColor: '#e91e63',
      label: 'Pink & Blue Grey',
      value: 'pink-bluegrey',
    },
    {
      backgroundColor: '#fff',
      buttonColor: '#4caf50',
      headingColor: '#9c27b0',
      label: 'Purple & Green',
      value: 'purple-green',
    },
  ];
  selectedTheme: Option;
  isSaveDisabled: boolean = false;
  constructor(
    private connectionService: ConnectionService,
    public permission: PermissionService,
    private location: Location,
    private _router: Router,
    private ngZone: NgZone,
    public themeService: ThemeService,
    public authService: AuthServiceService,
    @Inject(DOCUMENT) private document: Document,
    private _snackbar: MatSnackBar,
    @Inject(PLATFORM_ID) platformId?: Object
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
    }



  async ngOnInit() {
    console.log('AUTHSERVICE PROFILE CHECK', this.authService.profile);
    this.filteredTimezoneOptions = this.timeZoneControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
    this.filteredCurrencyOptions = this.currencyControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._currencyfilter(value))
    );
    if (this.authService.loggedIn) {
      let workspaceId = await this.connectionService.getWorkSpaceId();
      console.log("WORKSPACE ID",workspaceId);
      let token = await this.connectionService.getPreAuthenticatedToken();
      console.log("PRE AUTHENTICATED TOKEN",token);
      window.dispatchEvent(new Event('resize'));
      this.themeService.loadTheme();
      this.isDarkTheme = this.themeService.isDarkTheme;
      console.log("old saved", this.themeService.currentLocale)
      this.selectedCurrency =
        this.themeService.currentLocale.currency || 'Indian Rupee';
      this.selectedTimeZone =
        this.themeService.currentLocale.timeZone || Moment.tz.guess();
      this.selectedDateFormat =
        this.themeService.currentLocale.dateFormat || 'MM-dd-YYYY';
        this.displayDate = formatDate(new Date(), this.selectedDateFormat, 'en');
      this.selectedTimeFormat =
        this.themeService.currentLocale.timeFormat || 'HH:mm';
        this.displayTime = formatDate(new Date(), this.selectedTimeFormat, 'en');
        this.isCustomDateTime();
      this.seletedDecimalFormat =
        this.themeService.currentLocale.decimalFormat || '.';
      this.seletedDigitFormat =
        this.themeService.currentLocale.digitFormat || '12,34,56,789';
      this.direction = this.themeService.textDirection;
    } else {
      this.authService.authCheck();
      this.authService.authCheckPositive.pipe(takeUntil(this.destroy$)).subscribe((authStatus) => {
        //if logged in
        if (authStatus) {
          window.dispatchEvent(new Event('resize'));
          console.log('userprofileEmail', this.authService.profile);
          console.log('logged in');
          this.themeService.loadTheme();
          this.themeService
            .getExistingTheme(this.authService.profile._id)
            .then( async(res: any) => {
              if (res?.data != null) {
                console.log(res);
                this.themeService.settings_Id = res?.data[0]._id;
                let theme = res.data[0].themeSetting.theme;
                this.themeService.setTheme(theme);
                this.themeService.currentLocale = res.data[0].localeSetting;
                this.themeService.textDirection =
                  res.data[0].themeSetting.direction;
                if (res.data[0].themeSetting.direction == 'rtl') {
                  this.themeService.enableDirMode('rtl');
                }
              }
              console.log("old saved", this.themeService.currentLocale)
              this.isDarkTheme = this.themeService.isDarkTheme;
              this.selectedCurrency =
                this.themeService.currentLocale.currency || 'Indian Rupee';
              this.selectedTimeZone =
                this.themeService.currentLocale.timeZone || Moment.tz.guess();
              this.selectedDateFormat =
                this.themeService.currentLocale.dateFormat || 'MM-dd-YYYY';
                this.displayDate = formatDate(new Date(), this.selectedDateFormat, 'en');
              this.selectedTimeFormat =
                this.themeService.currentLocale.timeFormat || 'HH:mm';
                this.displayTime = formatDate(new Date(), this.selectedTimeFormat, 'en');
                this.isCustomDateTime();
              this.seletedDecimalFormat =
                this.themeService.currentLocale.decimalFormat || '.';
              this.seletedDigitFormat =
                this.themeService.currentLocale.digitFormat || '12,34,56,789';
              this.direction = this.themeService.textDirection;
              let workspaceId = await this.connectionService.getWorkSpaceId();
              console.log("WORKSPACE ID",workspaceId);
              let token = await this.connectionService.getPreAuthenticatedToken();
              console.log("PRE AUTHENTICATED TOKEN",token);
            });
        } else {
          // redirect to login page
          // this._snackbar.open('Apologies, the login attempt failed. Please reload the page and try logging in again.', 'ok', {
          //   horizontalPosition: 'center',
          //   verticalPosition: 'top',
          // });
          this.ngZone.run(() => {
            this.router.navigate(['../']);
          });

          return;
        }
      });
    }
  }
  updateDateFormat() {
    // Update the date format in the theme service
    this.themeService.setDateFormat(this.selectedDateFormat);
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.timeZoneLists.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  private _currencyfilter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.currency_list.filter(
      (option) =>
        option.name.toLowerCase().includes(filterValue) ||
        option.code.toLowerCase().includes(filterValue)
    );
  }

  toggleDarkTheme(checked: boolean) {
    console.log(checked);
    if (this.selectedTheme) {
      this.themeService.setDarkTheme(checked, this.selectedTheme.value);
    } else {
      this.themeService.setDarkTheme(checked);
    }
  }

  getCurrencySymbol(code: any) {
    return getCurrencySymbol(code, 'narrow');
  }

  themeChangeHandler(themeToSet: Option) {
    this.selectedTheme = themeToSet;
    console.log(themeToSet, this.themeService.isDarkTheme);
    this.themeService.setTheme(themeToSet.value, this.themeService.isDarkTheme);
  }

  resetTheme() {
    this.selectedTheme = undefined;
    console.log(this.themeService.isDarkTheme);
    this.themeService.resetTheme(this.themeService.isDarkTheme);
  }

  onDirectionChange(direction) {
    console.log(direction);
    this.themeService.enableDirMode(direction);
  }

  timezoneSelected(event: any) {
    this.filteredTimezoneOptions = this.timeZoneControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
    console.log('timezone selected', event, this.selectedTimeZone);
  }

  dateformatSelected(event?: any) {
    console.log("EVENT dateFormatSelected : ", event);

    if (this.selectedDateFormat === 'EEEE, MMMM dd, YYYY' || this.selectedDateFormat === 'MMM dd, YYYY' || this.selectedDateFormat === 'MM-dd-YYYY') {
      this.selectedCustomDateFormat = undefined;
      const currDate = new Date();
      this.displayDate = formatDate(currDate, this.selectedDateFormat, 'en');
      console.log("DATE IS IN FORMAT : ", this.selectedDateFormat, "TODAY'S DATE : ", this.displayDate);
    } else {
      this.displayDate = undefined;
      this.selectedCustomDateFormat = this.selectedCustomDateFormat ? this.selectedCustomDateFormat : 'MM-dd-YYYY';
      this.customDisplayDate = formatDate(new Date(), this.selectedCustomDateFormat, 'en');
    }
    this.emitOutput();
  }
  emitOutput() {
    throw new Error('Method not implemented.');
  }

  timeformatSelected(event?: any) {
    console.log("EVENT timeFormatSelected : ",event);
    if (this.selectedTimeFormat == 'hh:mm:ss a' ||  this.selectedTimeFormat == 'hh:mm a' || this.selectedTimeFormat == 'HH:mm'){
      this.selectedCustomTimeFormat = undefined;
      var currTime = new Date();
      this.displayTime = formatDate(currTime, this.selectedTimeFormat, 'en');
      console.log("TIME IS IN FORMAT : ",this.selectedTimeFormat, "TIME NOW : ",this.displayTime);
    }
    else{
      this.displayTime = undefined;
      this.selectedCustomTimeFormat = this.selectedCustomTimeFormat? this.selectedCustomTimeFormat : 'hh:mm a';
      this.customDisplayTime = formatDate(new Date(), this.selectedCustomTimeFormat, 'en');
    }
  }

  customTimeformatSelected(event: any) {
    console.log("EVENT customTimeFormatSelected : ",event);
    console.log(this.selectedCustomTimeFormat);
    this.timeFormat[3].value = this.selectedCustomTimeFormat;
    var currTime = new Date();
    this.customDisplayTime = formatDate(currTime, this.selectedCustomTimeFormat, 'en');
    console.log("TIME IS IN FORMAT : ",this.selectedCustomTimeFormat, "TIME NOW : ",this.customDisplayTime);
  }

  customDateformatSelected(event: any) {
    console.log(this.selectedCustomDateFormat);
    console.log("EVENT customDateFormatSelected : ",event);
    this.dateFormat[3].value = this.selectedCustomDateFormat;
    var currDate = new Date();
    this.customDisplayDate = formatDate(currDate, this.selectedCustomDateFormat, 'en');
    console.log("DATE IS IN FORMAT : ",this.selectedCustomDateFormat, "TODAY'S DATE : ",this.customDisplayDate);
  }

  clearCustomTime() {
    this.selectedCustomTimeFormat = undefined;
    this.selectedTimeFormat = this.themeService.currentLocale.timeFormat;
    this.displayTime=formatDate(new Date(), this.themeService.currentLocale.timeFormat || 'HH:mm', 'en');
    console.log(this.displayTime);
  }

  clearCustomDate() {
    this.selectedCustomDateFormat = undefined;
    this.selectedDateFormat = this.themeService.currentLocale.dateFormat;
    this.displayDate=formatDate(new Date(), this.themeService.currentLocale.dateFormat || 'MM-dd-YYYY', 'en');
    console.log(this.displayDate);
  }

  isCustomDateTime() {
    if (this.selectedTimeFormat != 'hh:mm:ss a' &&  this.selectedTimeFormat !='hh:mm a' && this.selectedTimeFormat !='HH:mm'){
      this.timeFormat[3].value = this.selectedTimeFormat;
      console.log("Current Custom time Format : ",this.timeFormat);
      this.displayTime = undefined;
      this.selectedCustomTimeFormat = this.themeService.currentLocale.timeFormat;
      this.customDisplayTime = formatDate(new Date(), this.selectedCustomTimeFormat || 'hh:mm a', 'en');
    }
    if (this.selectedDateFormat != 'EEEE, MMMM dd, YYYY' &&  this.selectedDateFormat !='MMM dd, YYYY' && this.selectedDateFormat !='MM-dd-YYYY'){
      this.dateFormat[3].value = this.selectedDateFormat;
      console.log("Current Custom date Format : ",this.dateFormat);
      this.displayDate = undefined;
      this.selectedCustomDateFormat = this.themeService.currentLocale.dateFormat;
      this.customDisplayDate = formatDate(new Date(), this.selectedCustomDateFormat || 'MM-dd-YYYY', 'en');
    }
  }

  currencySelected(event: any) {
    this.filteredCurrencyOptions = this.currencyControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._currencyfilter(value))
    );
    console.log('currency selected', event, this.selectedCurrency);
  }

  dateTimeFormatChanged(data){
    console.log("dateTimeFormat changed", data)
    this.selectedDateFormat = data.dateFormat
    this.selectedTimeFormat = data.timeFormat
  }

  onSaveClicked() {
    if (this.authService.loggedIn) {
      let localeObj: lcoale = {
        currency: this.selectedCurrency,
        timeZone: this.selectedTimeZone,
        // dateFormat: this.selectedCustomDateFormat ? this.selectedCustomDateFormat : this.selectedDateFormat,
        // timeFormat: this.selectedCustomTimeFormat ? this.selectedCustomTimeFormat : this.selectedTimeFormat,
        dateFormat: this.selectedDateFormat,
        timeFormat: this.selectedTimeFormat,
        decimalFormat: this.seletedDecimalFormat,
        digitFormat: this.seletedDigitFormat,
      };
      console.log("locale to save", localeObj)
      this.themeService.spinner = true;
      this.isSaveDisabled = true;
      this.themeService.saveTheme(localeObj).then(() => {
        this.themeService.spinner = false;
        this.isSaveDisabled = false;
        this._snackbar.open('Setting Saved Successfully', 'Dismiss', {
          duration: 3000,
        });
      });
    } else {
      console.log('Please Login/Sign Up First');
    }
  }

  navigateBack() {
    this.location.back();
  }

  trackByFn(index:number, item:any):any{
    return item || index
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete(); // Ensures cleanup
  }
}
